import * as T from './types'

export default {
    [T.SET_THEME_LIST](state, payload) {
        state.themeList = payload
    },
    [T.SET_CURRENT_THEME](state, payload) {
        state.currentSelectedTheme = payload
    },
    [T.SET_CURRENT_THEME_ID](state, payload) {
        state.currentSelectedThemeId = payload
    },
    [T.SET_THEME_LOADING](state, payload) {
        state.loading = payload
    },
}
